// src/store/slices/marketingLeadSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import marketingApi from "api/marketingApi";
import { toast } from "sonner";

const initialState = {
  // appDetails: [],
  // products: [],
  // messageLogs: [],
  // otherContacts: [],
  // campaigns: [],
  // contactGroups: [],
  // demoSchedules: [],
  //  demoSchedulesPagination: {
  // count: 0,    page_size: 10,
  // current_page: 1,
  // total_pages: 1  },
  // categories: [],
  // leadStatuses: [],
  // dashboardSummary: null,
  // pagination: { count: 0, page_size: 10 },importOtherContactsPreview
  // isLoading: false,
  // error: null,

  appDetails: [],
  products: [],
  productsPagination: {
    count: 0,
    page_size: 10,
    current_page: 1,
    total_pages: 1,
  },
  messageLogs: [],
  otherContacts: [],
  otherContactsPagination: {
    count: 0,
    page_size: 10,
    current_page: 1,
    total_pages: 1,
  },
  campaigns: [],
  campaignsPagination: {
    count: 0,
    page_size: 10,
    current_page: 1,
    total_pages: 1,
  },
  contactGroups: [],
  contactGroupsPagination: {
    count: 0,
    page_size: 10,
    current_page: 1,
    total_pages: 1,
  },
  demoSchedules: [],
  demoSchedulesPagination: {
    count: 0,
    page_size: 10,
    current_page: 1,
    total_pages: 1,
  },
  categories: [],
  categoriesPagination: {
    count: 0,
    page_size: 10,
    current_page: 1,
    total_pages: 1,
  },
  leadStatuses: [],
  dashboardSummary: null,
  leads: [],
  leadsPagination: { count: 0, page_size: 10, current_page: 1, total_pages: 1 },
  isLoading: false,
  error: null,
  leadShareHistory: [], // array of share logs
  selectedLeadForHistory: null, // current lead being viewed
  leadShareHistoryLoading: false,

  leadStatusHistory: [], // ← new

  leadStatusHistoryLoading: false, // ← new
  selectedLeadForStatusHistory: null, // ← new

    selectedMessageLogDetails: null, // Stores the details of the selected log
  messageLogDetailsLoading: false,  // Loading state for the details
};

// ────────────────────────────────────────────────
// App Details
// ────────────────────────────────────────────────
export const fetchAppDetails = createAsyncThunk(
  "marketing/fetchAppDetails",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getAppDetails(params);
      console.log("ss", res);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load app details",
      );
    }
  },
);

export const createAppDetail = createAsyncThunk(
  "marketing/createAppDetail",
  async (data, { rejectWithValue }) => {
    try {
      const res = await marketingApi.createAppDetail(data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to create app detail",
      );
    }
  },
);

export const updateAppDetail = createAsyncThunk(
  "marketing/updateAppDetail",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await marketingApi.updateAppDetail(id, data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update app detail",
      );
    }
  },
);

export const deleteAppDetail = createAsyncThunk(
  "marketing/deleteAppDetail",
  async (id, { rejectWithValue }) => {
    try {
      await marketingApi.deleteAppDetail(id);
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete app detail",
      );
    }
  },
);

// ────────────────────────────────────────────────
// Products
// ────────────────────────────────────────────────
export const fetchProducts = createAsyncThunk(
  "marketing/fetchProducts",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getProducts(params);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load products",
      );
    }
  },
);

export const createProduct = createAsyncThunk(
  "marketing/createProduct",
  async (data, { rejectWithValue }) => {
    try {
      const res = await marketingApi.createProduct(data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to create product");
    }
  },
);

export const updateProduct = createAsyncThunk(
  "marketing/updateProduct",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await marketingApi.updateProduct(id, data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to update product");
    }
  },
);

export const deleteProduct = createAsyncThunk(
  "marketing/deleteProduct",
  async (id, { rejectWithValue }) => {
    try {
      await marketingApi.deleteProduct(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to delete product");
    }
  },
);

// ────────────────────────────────────────────────
// Products Export / Import
// ────────────────────────────────────────────────
export const exportProducts = createAsyncThunk(
  "marketing/exportProducts",
  async (_, { rejectWithValue }) => {
    try {
      const blob = await marketingApi.exportProducts();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `products_${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      // console.log("sdfasdf", err)
      return rejectWithValue("Export failed");
    }
  },
);

export const importProductsPreview = createAsyncThunk(
  "marketing/importProductsPreview",
  async (file, { rejectWithValue }) => {
    try {
      const data = await marketingApi.importProductsPreview(file);
      return data;
    } catch (err) {
      const message = err.response?.data?.message || "Preview failed";
      toast.error(message);
      return rejectWithValue(message);
    }
  },
);

export const importProductsConfirm = createAsyncThunk(
  "marketing/importProductsConfirm",
  async (preview, { rejectWithValue, dispatch }) => {
    try {
      await marketingApi.importProductsConfirm(preview);
      // Refetch products to show new data
      dispatch(fetchProducts({ page: 1, page_size: 10 }));
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || "Import failed");
    }
  },
);


// ────────────────────────────────────────────────
// Message Logs
// ────────────────────────────────────────────────
export const fetchMessageLogs = createAsyncThunk(
  "marketing/fetchMessageLogs",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getMessageLogs(params);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load message logs",
      );
    }
  },
);

export const updateMessageLogStatus = createAsyncThunk(
  "marketing/updateMessageLogStatus",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await marketingApi.updateMessageLogStatus(id, data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to update message status",
      );
    }
  },
);

export const deleteMultipleMessageLogs = createAsyncThunk(
  "marketing/deleteMultipleMessageLogs",
  async (ids, { rejectWithValue }) => {
    try {
      await marketingApi.deleteMultipleMessageLogs(ids);
      return ids;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete message logs",
      );
    }
  },
);

// ────────────────────────────────────────────────
// Send / Create Message
// ────────────────────────────────────────────────
export const sendMessage = createAsyncThunk(
  "marketing/sendMessage",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await marketingApi.sendMessage(formData);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to send message",
      );
    }
  },
);

// ────────────────────────────────────────────────
// Get Single Message Log (optional – for details view if needed)
// ────────────────────────────────────────────────
export const fetchMessageLogById = createAsyncThunk(
  "marketing/fetchMessageLogById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getMessageLogById(id);
      
      // FIX: Return the full response (res), NOT res.data
      // Your reducer expects action.payload to be { success: true, data: {...} }
      // so that action.payload.data works.
      return res; 
      
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load message details",
      );
    }
  },
);

// ────────────────────────────────────────────────
// Other Contacts
// ────────────────────────────────────────────────
export const fetchOtherContacts = createAsyncThunk(
  "marketing/fetchOtherContacts",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getOtherContacts(params);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load other contacts",
      );
    }
  },
);

export const createOtherContact = createAsyncThunk(
  "marketing/createOtherContact",
  async (data, { rejectWithValue }) => {
    try {
      const res = await marketingApi.createOtherContact(data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to create contact");
    }
  },
);

export const updateOtherContact = createAsyncThunk(
  "marketing/updateOtherContact",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await marketingApi.updateOtherContact(id, data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to update contact");
    }
  },
);

export const deleteOtherContact = createAsyncThunk(
  "marketing/deleteOtherContact",
  async (id, { rejectWithValue }) => {
    try {
      await marketingApi.deleteOtherContact(id);
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete contact",
      );
    }
  },
);

export const exportOtherContacts = createAsyncThunk(
  "marketing/exportOtherContacts",
  async (_, { rejectWithValue }) => {
    try {
      const blob = await marketingApi.exportOtherContacts();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `contacts_${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      return rejectWithValue("Export failed");
    }
  },
);

// ────────────────────────────────────────────────
// Import Other Contacts Preview
// ────────────────────────────────────────────────
export const importOtherContactsPreview = createAsyncThunk(
  "marketing/importOtherContactsPreview",
  async (file, { rejectWithValue }) => {
    try {
      const data = await marketingApi.importOtherContactsPreview(file);
      return data;
    } catch (err) {
      const message = err.response?.data?.message || "Preview failed";
      toast.error(message);
      return rejectWithValue(message);
    }
  },
);

// ────────────────────────────────────────────────
// Import Other Contacts Confirm
// ────────────────────────────────────────────────
export const importOtherContactsConfirm = createAsyncThunk(
  "marketing/importOtherContactsConfirm",
  async (preview, { rejectWithValue, dispatch }) => {
    try {
      await marketingApi.importOtherContactsConfirm(preview);
      // Refetch contacts to show new data
      dispatch(fetchOtherContacts({ page: 1, page_size: 10 }));
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || "Import failed");
    }
  },
);

// ────────────────────────────────────────────────
// Campaigns
// ────────────────────────────────────────────────
export const fetchCampaigns = createAsyncThunk(
  "marketing/fetchCampaigns",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getCampaigns(params);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load campaigns",
      );
    }
  },
);

export const createCampaign = createAsyncThunk(
  "marketing/createCampaign",
  async (data, { rejectWithValue }) => {
    try {
      const res = await marketingApi.createCampaign(data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to create campaign");
    }
  },
);

export const updateCampaign = createAsyncThunk(
  "marketing/updateCampaign",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await marketingApi.updateCampaign(id, data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to update campaign");
    }
  },
);

export const deleteCampaign = createAsyncThunk(
  "marketing/deleteCampaign",
  async (id, { rejectWithValue }) => {
    try {
      await marketingApi.deleteCampaign(id);
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete campaign",
      );
    }
  },
);

// ────────────────────────────────────────────────
// Contact Groups
// ────────────────────────────────────────────────
export const fetchContactGroups = createAsyncThunk(
  "marketing/fetchContactGroups",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getContactGroups(params);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load contact groups",
      );
    }
  },
);

export const createContactGroup = createAsyncThunk(
  "marketing/createContactGroup",
  async (data, { rejectWithValue }) => {
    try {
      const res = await marketingApi.createContactGroup(data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to create contact group",
      );
    }
  },
);

export const updateContactGroup = createAsyncThunk(
  "marketing/updateContactGroup",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await marketingApi.updateContactGroup(id, data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to update contact group",
      );
    }
  },
);

export const deleteContactGroup = createAsyncThunk(
  "marketing/deleteContactGroup",
  async (id, { rejectWithValue }) => {
    try {
      await marketingApi.deleteContactGroup(id);
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete contact group",
      );
    }
  },
);

// ────────────────────────────────────────────────
// Demo Schedules
// ────────────────────────────────────────────────
export const fetchDemoSchedules = createAsyncThunk(
  "marketing/fetchDemoSchedules",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getDemoSchedules(params);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load demo schedules",
      );
    }
  },
);

export const createDemoSchedule = createAsyncThunk(
  "marketing/createDemoSchedule",
  async (data, { rejectWithValue }) => {
    try {
      const res = await marketingApi.createDemoSchedule(data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to create demo schedule",
      );
    }
  },
);

export const updateDemoSchedule = createAsyncThunk(
  "marketing/updateDemoSchedule",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await marketingApi.updateDemoSchedule(id, data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to update demo schedule",
      );
    }
  },
);

export const deleteDemoSchedule = createAsyncThunk(
  "marketing/deleteDemoSchedule",
  async (id, { rejectWithValue }) => {
    try {
      await marketingApi.deleteDemoSchedule(id);
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete demo schedule",
      );
    }
  },
);

// ────────────────────────────────────────────────
// Categories
// ────────────────────────────────────────────────
export const fetchCategories = createAsyncThunk(
  "marketing/fetchCategories",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getCategories(params);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load categories",
      );
    }
  },
);

export const createCategory = createAsyncThunk(
  "marketing/createCategory",
  async (data, { rejectWithValue }) => {
    try {
      const res = await marketingApi.createCategory(data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to create category");
    }
  },
);

export const updateCategory = createAsyncThunk(
  "marketing/updateCategory",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await marketingApi.updateCategory(id, data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to update category");
    }
  },
);

export const deleteCategory = createAsyncThunk(
  "marketing/deleteCategory",
  async (id, { rejectWithValue }) => {
    try {
      await marketingApi.deleteCategory(id);
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete category",
      );
    }
  },
);

// ────────────────────────────────────────────────
// Lead Statuses
// ────────────────────────────────────────────────
export const fetchLeadStatuses = createAsyncThunk(
  "marketing/fetchLeadStatuses",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getLeadStatuses(params);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load lead statuses",
      );
    }
  },
);

export const createLeadStatus = createAsyncThunk(
  "marketing/createLeadStatus",
  async (data, { rejectWithValue }) => {
    try {
      const res = await marketingApi.createLeadStatus(data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to create lead status",
      );
    }
  },
);

export const updateLeadStatus = createAsyncThunk(
  "marketing/updateLeadStatus",
  async ({ id, ...data }, { rejectWithValue }) => {
    try {
      const res = await marketingApi.updateLeadStatus(id, data);
      return res.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || "Failed to update lead status",
      );
    }
  },
);

export const deleteLeadStatus = createAsyncThunk(
  "marketing/deleteLeadStatus",
  async (id, { rejectWithValue }) => {
    try {
      await marketingApi.deleteLeadStatus(id);
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete lead status",
      );
    }
  },
);

// ────────────────────────────────────────────────
// Leads
// ────────────────────────────────────────────────
export const fetchLeads = createAsyncThunk(
  "marketing/fetchLeads",
  async (params, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getLeads(params);
      return res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load leads",
      );
    }
  },
);

export const createLead = createAsyncThunk(
  "marketing/createLead",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await marketingApi.createLead(formData); // ← formData, not JSON
      return res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to create lead");
    }
  },
);

export const updateLead = createAsyncThunk(
  "marketing/updateLead",
  async ({ id, data: formData }, { rejectWithValue }) => {
    // ← renamed to data
    try {
      const res = await marketingApi.updateLead(id, formData);
      return res;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to update lead");
    }
  },
);
export const deleteLead = createAsyncThunk(
  "marketing/deleteLead",
  async (id, { rejectWithValue }) => {
    try {
      await marketingApi.deleteLead(id);
      return id;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to delete lead",
      );
    }
  },
);

export const fetchLeadShareHistory = createAsyncThunk(
  "marketing/fetchLeadShareHistory",
  async (leadId, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getLeadShareHistory(leadId);
      return { leadId, history: res.data || res }; // adjust based on your response shape
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load share history",
      );
    }
  },
);

export const convertLeadToContact = createAsyncThunk(
  "marketing/convertLeadToContact",
  async (leadId, { rejectWithValue }) => {
    try {
      const res = await marketingApi.addContactFromLead(leadId, {});
      return { leadId, contact: res.data?.contact || res }; // assuming backend returns the new contact
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to convert lead to contact",
      );
    }
  },
);

export const fetchLeadStatusHistory = createAsyncThunk(
  "marketing/fetchLeadStatusHistory",
  async (leadId, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getLeadStatusHistory(leadId);
      return { leadId, history: res.data || [] };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load status history",
      );
    }
  },
);

// ────────────────────────────────────────────────
// Import / Export Leads
// ────────────────────────────────────────────────
export const exportLeads = createAsyncThunk(
  "marketing/exportLeads",
  async (_, { rejectWithValue }) => {
    try {
      const blob = await marketingApi.exportLeads();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `leads_${new Date().toISOString().slice(0, 10)}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      return rejectWithValue("Export failed");
    }
  },
);

export const importLeadsPreview = createAsyncThunk(
  "marketing/importLeadsPreview",
  async (file, { rejectWithValue }) => {
    try {
      const data = await marketingApi.importLeadsPreview(file);
      return data;
    } catch (err) {
      const message = err.response?.data?.message || "Preview failed";
      toast.error(message);
      return rejectWithValue(message);
    }
  },
);

export const importLeadsConfirm = createAsyncThunk(
  "marketing/importLeadsConfirm",
  async (preview, { rejectWithValue, dispatch }) => {
    try {
      await marketingApi.importLeadsConfirm(preview);
      // Refetch leads to show new data
      dispatch(fetchLeads({ page: 1, page_size: 10 }));
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || "Import failed");
    }
  },
);

// ────────────────────────────────────────────────
// Dashboard Summary
// ────────────────────────────────────────────────
export const fetchMarketingDashboardSummary = createAsyncThunk(
  "marketing/fetchDashboardSummary",
  async (_, { rejectWithValue }) => {
    try {
      const res = await marketingApi.getDashboardSummary();
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load dashboard summary",
      );
    }
  },
);

const marketingLeadSlice = createSlice({
  name: "marketingLead",
  initialState,
  reducers: {
    clearMarketingError: (state) => {
      state.error = null;
    },
   clearMessageLogDetails: (state) => {
      state.selectedMessageLogDetails = null;
    },
  },
  extraReducers: (builder) => {
    const handlePending = (state) => {
      state.isLoading = true;
      state.error = null;
    };

    const handleListFulfilled = (state, action, key) => {
      state.isLoading = false;
      state[key] = action.payload.data || action.payload || [];
      if (action.payload.pagination) {
        state.pagination = action.payload.pagination;
      }
    };

    const handleRejected = (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    };

    // ── App Details ───────────────────────────────────────
    builder
      .addCase(fetchAppDetails.pending, handlePending)
      .addCase(fetchAppDetails.fulfilled, (state, action) =>
        handleListFulfilled(state, action, "appDetails"),
      )
      .addCase(fetchAppDetails.rejected, handleRejected)
      .addCase(createAppDetail.fulfilled, (state, action) => {
        state.appDetails.unshift(action.payload);
        state.pagination.count += 1;
      })
      .addCase(updateAppDetail.fulfilled, (state, action) => {
        const index = state.appDetails.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) state.appDetails[index] = action.payload;
      })
      .addCase(deleteAppDetail.fulfilled, (state, action) => {
        state.appDetails = state.appDetails.filter(
          (item) => item.id !== action.payload,
        );
        state.pagination.count = Math.max(0, state.pagination.count - 1);
      });

    // ── Products ─────────────────────────────────────────
    builder
      .addCase(fetchProducts.pending, handlePending)
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.products = action.payload.data || action.payload || [];
        if (action.payload.pagination) {
          state.productsPagination = action.payload.pagination;
        }
      })
      .addCase(fetchProducts.rejected, handleRejected)
      .addCase(createProduct.fulfilled, (state, action) => {
        state.products.unshift(action.payload);
        state.productsPagination.count += 1;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        const index = state.products.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) state.products[index] = action.payload;
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.products = state.products.filter(
          (item) => item.id !== action.payload,
        );
        state.productsPagination.count = Math.max(
          0,
          state.productsPagination.count - 1,
        );
      })
       .addCase(exportProducts.rejected, (state, action) => {
      state.error = action.payload;
    })
    .addCase(importProductsConfirm.fulfilled, (state, action) => {
      // Usually refetch is handled inside the thunk, 
      // but we can also do it here if we want.
      // dispatch(fetchProducts({ page: 1, page_size: 10 })); 
    })
    .addCase(importProductsConfirm.rejected, (state, action) => {
      state.error = action.payload;
    })

      // ── Message Logs ──────────────────────────────────────
      .addCase(fetchMessageLogs.pending, handlePending)
      .addCase(fetchMessageLogs.fulfilled, (state, action) =>
        handleListFulfilled(state, action, "messageLogs"),
      )
      .addCase(fetchMessageLogs.rejected, handleRejected)

      // ── Send / Create Message ────────────────────────────────
      .addCase(sendMessage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.isLoading = false;
        // Optimistic: add new message log entry to list (if backend returns full object)
        if (action.payload) {
          state.messageLogs.unshift(action.payload);
          state.pagination.count += 1;
        }
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // ── Single Message Log (optional) ────────────────────────
      .addCase(fetchMessageLogById.pending, (state) => {
        state.messageLogDetailsLoading = true;
        state.error = null;
      })
      .addCase(fetchMessageLogById.fulfilled, (state, action) => {
        state.messageLogDetailsLoading = false;
        // Based on your JSON, the data is at action.payload.data
        // action.payload is { success: true, data: { campaign: ... } }
        // So we take action.payload.data
        state.selectedMessageLogDetails = action.payload.data || null;
      })
      .addCase(fetchMessageLogById.rejected, (state, action) => {
        state.messageLogDetailsLoading = false;
        state.error = action.payload;
      })
      // ── Other Contacts ───────────────────────────────────
      .addCase(fetchOtherContacts.pending, handlePending)
      .addCase(fetchOtherContacts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.otherContacts = action.payload.data || action.payload || [];
        if (action.payload.pagination) {
          state.otherContactsPagination = action.payload.pagination;
        }
      })
      .addCase(fetchOtherContacts.rejected, handleRejected)
      .addCase(createOtherContact.fulfilled, (state, action) => {
        state.otherContacts.unshift(action.payload);
        state.otherContactsPagination.count += 1;
      })
      .addCase(updateOtherContact.fulfilled, (state, action) => {
        const index = state.otherContacts.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) state.otherContacts[index] = action.payload;
      })
      .addCase(deleteOtherContact.fulfilled, (state, action) => {
        state.otherContacts = state.otherContacts.filter(
          (item) => item.id !== action.payload,
        );
        state.otherContactsPagination.count = Math.max(
          0,
          state.otherContactsPagination.count - 1,
        );
      });
    builder
      .addCase(exportOtherContacts.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Handle Import Errors
      // builder.addCase(importOtherContactsPreview.rejected, (state, action) => {
      //   state.error = action.payload;
      // });

      // builder
      //   .addCase(importOtherContactsConfirm.rejected, (state, action) => {
      //     state.error = action.payload;
      //   })

      // ── Campaigns ────────────────────────────────────────
      .addCase(fetchCampaigns.pending, handlePending)
      .addCase(fetchCampaigns.fulfilled, (state, action) => {
        state.isLoading = false;
        state.campaigns = action.payload.data || action.payload || [];
        if (action.payload.pagination) {
          state.campaignsPagination = action.payload.pagination;
        }
      })
      .addCase(fetchCampaigns.rejected, handleRejected)
      .addCase(createCampaign.fulfilled, (state, action) => {
        state.campaigns.unshift(action.payload);
        state.campaignsPagination.count += 1;
      })
      .addCase(updateCampaign.fulfilled, (state, action) => {
        const index = state.campaigns.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) state.campaigns[index] = action.payload;
      })
      .addCase(deleteCampaign.fulfilled, (state, action) => {
        state.campaigns = state.campaigns.filter(
          (item) => item.id !== action.payload,
        );
        state.campaignsPagination.count = Math.max(
          0,
          state.campaignsPagination.count - 1,
        );
      })

      // ── Contact Groups ───────────────────────────────────
      .addCase(fetchContactGroups.pending, handlePending)
      .addCase(fetchContactGroups.fulfilled, (state, action) => {
        state.isLoading = false;
        state.contactGroups = action.payload.data || action.payload || [];
        if (action.payload.pagination) {
          state.contactGroupsPagination = action.payload.pagination;
        }
      })
      .addCase(fetchContactGroups.rejected, handleRejected)
      .addCase(createContactGroup.fulfilled, (state, action) => {
        state.contactGroups.unshift(action.payload);
        state.contactGroupsPagination.count += 1;
      })
      .addCase(updateContactGroup.fulfilled, (state, action) => {
        const index = state.contactGroups.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) state.contactGroups[index] = action.payload;
      })
      .addCase(deleteContactGroup.fulfilled, (state, action) => {
        state.contactGroups = state.contactGroups.filter(
          (item) => item.id !== action.payload,
        );
        state.contactGroupsPagination.count = Math.max(
          0,
          state.contactGroupsPagination.count - 1,
        );
      })

      // ── Demo Schedules ───────────────────────────────────
      .addCase(fetchDemoSchedules.pending, handlePending)
      .addCase(fetchDemoSchedules.fulfilled, (state, action) => {
        state.isLoading = false;
        state.demoSchedules = action.payload.data || action.payload || [];
        if (action.payload.pagination) {
          state.demoSchedulesPagination = action.payload.pagination;
        }
      })
      .addCase(fetchDemoSchedules.rejected, handleRejected)
      .addCase(createDemoSchedule.fulfilled, (state, action) => {
        state.demoSchedules.unshift(action.payload);
        state.demoSchedulesPagination.count += 1;
      })
      .addCase(updateDemoSchedule.fulfilled, (state, action) => {
        const index = state.demoSchedules.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) state.demoSchedules[index] = action.payload;
      })
      .addCase(deleteDemoSchedule.fulfilled, (state, action) => {
        state.demoSchedules = state.demoSchedules.filter(
          (item) => item.id !== action.payload,
        );
        state.demoSchedulesPagination.count = Math.max(
          0,
          state.demoSchedulesPagination.count - 1,
        );
      })

      // ── Categories ───────────────────────────────────────
      .addCase(fetchCategories.pending, handlePending)
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categories = action.payload.data || action.payload || [];
        if (action.payload.pagination) {
          state.categoriesPagination = action.payload.pagination;
        }
      })
      .addCase(fetchCategories.rejected, handleRejected)
      .addCase(createCategory.fulfilled, (state, action) => {
        state.categories.unshift(action.payload);
        state.categoriesPagination.count += 1;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        const index = state.categories.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) state.categories[index] = action.payload;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.categories = state.categories.filter(
          (item) => item.id !== action.payload,
        );
        state.categoriesPagination.count = Math.max(
          0,
          state.categoriesPagination.count - 1,
        );
      })

      // Lead Statuses
      .addCase(fetchLeadStatuses.pending, handlePending)
      .addCase(fetchLeadStatuses.fulfilled, (state, action) =>
        handleListFulfilled(state, action, "leadStatuses"),
      )
      .addCase(fetchLeadStatuses.rejected, handleRejected)

      .addCase(createLeadStatus.fulfilled, (state, action) => {
        state.leadStatuses.unshift(action.payload);
        state.pagination.count += 1;
      })
      .addCase(updateLeadStatus.fulfilled, (state, action) => {
        const index = state.leadStatuses.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) state.leadStatuses[index] = action.payload;
      })
      .addCase(deleteLeadStatus.fulfilled, (state, action) => {
        state.leadStatuses = state.leadStatuses.filter(
          (item) => item.id !== action.payload,
        );
        state.pagination.count = Math.max(0, state.pagination.count - 1);
      })
      // ── Leads ────────────────────────────────────────────
      .addCase(fetchLeads.pending, handlePending)
      .addCase(fetchLeads.fulfilled, (state, action) => {
        state.isLoading = false;
        state.leads = action.payload.data || action.payload || [];
        if (action.payload.pagination) {
          state.leadsPagination = action.payload.pagination;
        }
      })
      .addCase(fetchLeads.rejected, handleRejected)
      .addCase(createLead.fulfilled, (state, action) => {
        state.leads.unshift(action.payload);
        state.leadsPagination.count += 1;
      })
      .addCase(updateLead.fulfilled, (state, action) => {
        const index = state.leads.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) state.leads[index] = action.payload;
      })
      .addCase(deleteLead.fulfilled, (state, action) => {
        state.leads = state.leads.filter((item) => item.id !== action.payload);
        state.leadsPagination.count = Math.max(
          0,
          state.leadsPagination.count - 1,
        );
      })

      .addCase(convertLeadToContact.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(convertLeadToContact.fulfilled, (state, action) => {
        state.isLoading = false;
        // Remove the lead from the list (optimistic UI)
        state.leads = state.leads.filter((l) => l.id !== action.payload.leadId);
        state.leadsPagination.count = Math.max(
          0,
          state.leadsPagination.count - 1,
        );
        // Optional: you could add the new contact to otherContacts if you fetch them
      })
      .addCase(convertLeadToContact.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchLeadShareHistory.pending, (state) => {
        state.leadShareHistoryLoading = true;
        state.error = null;
      })
      .addCase(fetchLeadShareHistory.fulfilled, (state, action) => {
        state.leadShareHistoryLoading = false;
        state.leadShareHistory = action.payload.history || [];
        state.selectedLeadForHistory = action.payload.leadId;
      })
      .addCase(fetchLeadShareHistory.rejected, (state, action) => {
        state.leadShareHistoryLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchLeadStatusHistory.pending, (state) => {
        state.leadStatusHistoryLoading = true;
        state.error = null;
      })
      .addCase(fetchLeadStatusHistory.fulfilled, (state, action) => {
        state.leadStatusHistoryLoading = false;
        state.leadStatusHistory = action.payload.history;
        state.selectedLeadForStatusHistory = action.payload.leadId;
      })
      .addCase(fetchLeadStatusHistory.rejected, (state, action) => {
        state.leadStatusHistoryLoading = false;
        state.error = action.payload;
      });
    builder
      .addCase(exportLeads.rejected, (state, action) => {
        state.error = action.payload;
      })
      // ── Dashboard Summary ─────────────────────────────────
      .addCase(fetchMarketingDashboardSummary.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMarketingDashboardSummary.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dashboardSummary = action.payload;
      })
      .addCase(fetchMarketingDashboardSummary.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMarketingError, clearMessageLogDetails } = marketingLeadSlice.actions;
export default marketingLeadSlice.reducer;
